import { debounce } from "lodash-es";

/**
 * 在 Vue created() 内调用，可以将 this.xxx 的值和 localStorage 保持同步。
 *
 * 在需要保存状态的时候很有用。
 *
 * @template T
 * @param {T} instance
 * @param {string} componentName
 * @param {keyof T} dataName
 * @return {*} localStorage读取成功时返回读取到的值 否则为undefined
 */
export function vueLinkLocalStorage(instance, componentName, dataName) {
  return vueLinkStorage(instance, componentName, dataName, localStorage);
}

/**
 * 使用sessionStorage进行状态同步
 * @template T
 * @param {T} instance
 * @param {string} componentName
 * @param {keyof T} dataName
 * @returns {*}
 */
export function vueLinkSessionStorage(instance, componentName, dataName) {
  return vueLinkStorage(instance, componentName, dataName, sessionStorage);
}
export function concatStorageKey(componentName, dataName) {
  return `uicore:${componentName}:${dataName}`;
}
export function vueLinkReadOnce(instance, componentName, dataName, storageInstance) {
  const key = concatStorageKey(componentName, dataName);
  try {
    const val = storageInstance.getItem(key);
    if (val !== null) {
      // eslint-disable-next-line no-param-reassign
      instance[dataName] = JSON.parse(val);
    }
  } catch (error) {}
  return instance[dataName];
}
export function vueLinkWriteOnce(instance, componentName, dataName, storageInstance, value) {
  const key = concatStorageKey(componentName, dataName);
  try {
    storageInstance.setItem(key, JSON.stringify(value));
  } catch (error) {}
}
function vueLinkStorage(instance, componentName, dataName, storageInstance) {
  vueLinkReadOnce(instance, componentName, dataName, storageInstance);
  const write = debounce(() => {
    vueLinkWriteOnce(instance, componentName, dataName, storageInstance, instance[dataName]);
  }, 200);
  instance.$watch(dataName, write, {
    deep: true
  });
  instance.$once('hook:beforeDestroy', () => write.flush());
  // 读取成功时返回读到的值
  return instance[dataName];
}